module.exports = __webpack_public_path__ + "static/fire-1d048e0d88051e70b9abd72fc09254b4.png";